module.exports = __webpack_public_path__ + "static/media/disboard-logo-alt.39e1e3a8.svg";